/* eslint-disable react/jsx-props-no-multi-spaces */
import React, {
  useState, Fragment,
} from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { CountryCodes } from '@Apis/constants';
import {
  Table, Select, Popconfirm, Button, Popover, Checkbox, Drawer, notification,
  Divider,
} from 'antd';
import PropTypes from 'prop-types';
import {
  DeleteOutlined, CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCirclePlus, faCopy } from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';
import RfqActions from '@Actions/purchase/rfq/rfqActions';
import H3FormInput from '@Uilib/h3FormInput';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import NoBom from '@Images/NoBOM.png';
import RfqVendorSelector from '@Components/Purchase/Rfq/ViewRfq/Invitees/RfqVendorSelector';
import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const Invitees = ({
  participants, user, loading, callback, sendRfqNotificationLoading, formSubmitted, handleSubmit,
  handleDelete, selectedRfq, updateData, data, isEditing, setIsEditing, sendRfqNotification, updateRfqParticipant,
}) => {
  const [editingKey, setEditingKey] = useState('');
  const [emailAll, setEmailAll] = useState(true);
  const [whatsappAll, setWhatsappAll] = useState(true);
  const [showNotifyPopup, setShowNotifyPopup] = useState(false);
  const [showAddVendorsDrawer, setShowAddVendorsDrawer] = useState(false);

  const countryDialCodeOptions = CountryCodes?.map((item) => ({
    key: item?.name,
    value: item?.dial_code,
    label: `${item?.flag} +${item?.dial_code}`,
  }));

  const getColumns = () => {
    const columns = [
      {
        title: 'Vendor',
        editable: true,
        render: (record) => (
          <div style={{ width: '160px' }}>
            <div
              className="invitees-table-input"
            >
              {record?.seller_name}
            </div>
          </div>
        ),
      },
      {
        title: 'Products',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        editable: true,
        render: (record) => {
          const selectedProductIds = record?.product_sku_ids?.length > 0 ? record?.product_sku_ids : [];
          return (
            <div style={{ width: '400px' }}>
              <PRZSelect
                mode="tags"
                placeholder="Select product"
                maxTagCount="responsive"
                value={selectedProductIds}
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(data));
                  for (let i = 0; i < copyData?.length; i++) {
                    if (copyData[i]?.key === record?.key) {
                      copyData[i].product_sku_ids = value;
                    }
                  }
                  updateData(copyData);
                }}
                // showSearch
                style={{
                  width: '384px',
                }}
                dropdownRender={(menu) => (
                  <div>
                    {menu}
                    <Divider style={{ margin: '4px 0' }} />
                    <Button
                      type="primary"
                      ghost
                      style={{ width: '100%', textAlign: 'center' }}
                      onClick={() => {
                        const payload = {
                          rfq_id: selectedRfq?.rfq_id,
                          rfq_participant_id: record?.rfq_participant_id,
                          action: 'SAVE_PRODUCT',
                          product_rfq_line_ids: selectedRfq?.rfq_lines?.filter((line) => selectedProductIds.includes(line.product_sku_id)).map((line) => line.rfq_line_id),
                        };
                        if (!record?.negotiations?.length) {
                          updateRfqParticipant([payload], () => {
                            callback();
                          });
                        } else {
                          notification.open({
                            type: 'error',
                            message: 'Updates to products are not permitted once negotiations have been initiated.',
                            duration: 4,
                            placement: 'top',
                          });
                        }
                      }}
                    >
                      Save
                    </Button>
                  </div>
                )}
              >
                {selectedRfq?.rfq_lines?.map((product) => (
                  <Select.Option
                    key={product.product_sku_id}
                    value={product.product_sku_id}
                    style={{ backgroundColor: 'transparent', outline: 'none' }}
                    disabled={record?.negotiations?.length}
                  >
                    <Checkbox
                      checked={selectedProductIds.includes(product.product_sku_id)}
                      disabled={record?.negotiations?.length}
                      onChange={(e) => {
                        const value = e.target.checked
                          ? [...selectedProductIds, product.product_sku_id]
                          : selectedProductIds?.filter((id) => id !== product.product_sku_id);
                        const copyData = JSON.parse(JSON.stringify(data));
                        for (let i = 0; i < copyData?.length; i++) {
                          if (copyData[i]?.key === record?.key) {
                            copyData[i].product_sku_ids = value;
                          }
                        }
                        updateData(copyData);
                      }}
                    >
                      <H3Text
                        text={`#${product?.product_sku_info?.internal_sku_code || ''} ${product?.product_sku_info?.product_sku_name}`}
                        className="product-filter__option-text"
                      />
                    </Checkbox>
                  </Select.Option>
                ))}
              </PRZSelect>
            </div>
          );
        },
      },
      {
        title: 'Contact Number',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        editable: true,
        render: (record) => {
          const editable = record.key === editingKey;
          return (
            <div style={{ display: 'flex', alignItems: 'center', width: '200px' }}>
              {(record?.rfq_participant_id ? (editable && isEditing) : !(record?.phId?.length === 10)) ? (
                <Fragment>
                  <div>
                    <PRZSelect
                      value={record?.dial_code}
                      showSearch
                      filterOption={(input, option) => {
                        const { label } = option.props;
                        const { value } = option.props;
                        return (
                          label.toLowerCase().includes(input.toLowerCase())
                          || value.toLowerCase().includes(input.toLowerCase())
                        );
                      }}
                      onChange={(value) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        for (let i = 0; i < copyData?.length; i++) {
                          if (copyData[i]?.key === record?.key) {
                            copyData[i].dial_code = value;
                          }
                        }
                        updateData(copyData);
                      }}
                      className={formSubmitted && !record?.dial_code ? 'prz-select__error-border' : ''}
                      style={{
                        width: '60px',
                        backgroundColor: 'white',
                      }}
                      options={countryDialCodeOptions}
                    />
                  </div>
                  <H3FormInput
                    value={record?.phone_number}
                    maxlength="10"
                    type="text"
                    containerClassName="orgInputContainer invitees-input"
                    labelClassName="orgFormLabel"
                    placeholder="phone number.."
                    inputClassName={(formSubmitted && (!record?.phone_number || record?.phone_number?.length !== 10)) ? 'orgFormInputError' : 'orgFormInput'}
                    onChange={(event) => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      for (let i = 0; i < copyData?.length; i++) {
                        if (copyData[i]?.key === record?.key) {
                          copyData[i].phone_number = event.target.value;
                          copyData[i].phId = event.target.value;
                        }
                      }
                      updateData(copyData);
                    }}
                    style={{ width: '140px' }}
                  />
                </Fragment>
              ) : (
                <div
                  className="invitees-table-input"
                  onClick={() => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    for (let i = 0; i < copyData?.length; i++) {
                      if (copyData[i]?.key === record?.key) {
                        copyData[i].phId = '';
                      }
                    }
                    updateData(copyData);
                    setEditingKey(record?.key);
                    setIsEditing(true);
                  }}
                >
                  {`${CountryCodes?.find((code) => code?.dial_code == record?.dial_code)?.flag} +${record?.dial_code} ${record?.phone_number}`}
                </div>
              )}
            </div>
          );
        },
      },
      {
        title: 'Email',
        editable: true,
        render: (record) => {
          const editable = record.key === editingKey;
          return (
            <div style={{ display: 'flex', alignItems: 'center', width: '140px' }}>
              {(record?.rfq_participant_id ? (editable && isEditing) : true) ? (
                <H3FormInput
                  value={record?.email}
                  maxlength="100"
                  type="text"
                  containerClassName="orgInputContainer invitees-input"
                  labelClassName="orgFormLabel"
                  placeholder="email id.."
                  inputClassName={(formSubmitted && !record?.email) ? 'orgFormInputError' : 'orgFormInput'}
                  onChange={(event) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    for (let i = 0; i < copyData?.length; i++) {
                      if (copyData[i]?.key === record?.key) {
                        copyData[i].email = event.target.value;
                      }
                    }
                    updateData(copyData);
                  }}
                />
              ) : (
                <div
                  className="invitees-table-input"
                  onClick={() => {
                    setEditingKey(record?.key);
                    setIsEditing(true);
                  }}
                >
                  {record?.email}
                </div>
              )}
            </div>
          );
        },
      },
      {
        title: '',
        className: 'list__actions-column',
        width: '30px',
        fixed: 'right',
        render: (text, record) => {
          const editable = record.key === editingKey;
          return (
            (record.rfq_participant_id ? (
              <Fragment>
                {(editable && isEditing) ? (Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION,
                  Helpers.permissionTypes.UPDATE, user)
                  && (
                    <div className="list__actions">
                      <div
                        className="list__actions-button"
                        onClick={() => {
                          handleSubmit('UPDATE', record);
                        }}
                      >
                        <CheckOutlined />
                      </div>
                      <div
                        className="list__actions-button"
                        onClick={() => {
                          setEditingKey('');
                          setIsEditing(false);
                        }}
                      >
                        <CloseOutlined
                          style={{ color: 'red' }}
                        />
                      </div>
                      <div className="list__actions-button" />
                      <div className="list__actions-button" />
                    </div>
                  )
                ) : (
                  <div className="list__actions">
                    {!['DRAFT', 'VOID', 'COMPLETED'].includes(selectedRfq?.status) && (
                      <Popover
                        placement="topRight"
                        title="Notify participant?"
                        content={(
                          <React.Fragment>
                            <Checkbox checked={record?.whatsapp_enabled}>Whatsapp</Checkbox>
                            <Checkbox checked={record?.email_enabled}>Email</Checkbox>
                            <Button
                              onClick={() => {
                                sendRfqNotification({
                                  participants: [record?.rfq_participant_id],
                                  notification_type: 'RFQ_INITIAL',
                                  send_whatsapp_notification: record?.whatsapp_enabled,
                                  send_email_notification: record?.email_enabled,
                                });
                              }}
                              type="primary"
                              size="small"
                              disabled={!record?.whatsapp_enabled && !record?.email_enabled || !record?.product_sku_ids?.length}
                              loading={sendRfqNotificationLoading}
                            >
                              Notify Vendor
                            </Button>
                          </React.Fragment>
                        )}
                        trigger="click"
                      >
                        <H3Text
                          text={<FontAwesomeIcon icon={faBell} />}
                          className="invitees__table-action list__actions-button-delete"
                        />
                      </Popover>
                    )}
                    <H3Text
                      onClick={() => {
                        if (record?.product_sku_ids?.length > 0) {
                          navigator.clipboard.writeText(`${window.location.origin}/rfq?token=${record?.public_token}`);
                          notification.open({
                            type: 'success',
                            duration: 4,
                            placement: 'top',
                            message: 'Invitation link copied',
                          });
                        }
                      }}
                      text={(
                        <FontAwesomeIcon
                          icon={faCopy}
                          style={{
                            color: record?.product_sku_ids?.length > 0 ? '2d7df7' : 'gray',
                          }}
                        />
                      )}
                      className="invitees__table-action list__actions-button-delete"
                    />
                    {!['VOID', 'COMPLETED'].includes(selectedRfq?.status) && (
                      <Popconfirm
                        placement="topRight"
                        title="Are you sure you want remove this seller?"
                        onConfirm={() => {
                          handleSubmit('REMOVE', record);
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                        <div
                          className="list__actions-button-delete"
                        >
                          <DeleteOutlined />
                        </div>
                      </Popconfirm>
                    )}
                  </div>
                )}
              </Fragment>
            ) : (
              <Fragment>
                {Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION,
                  Helpers.permissionTypes.DELETE, user) && (
                    <div className="list__actions">
                      <div
                        onClick={() => handleDelete(record.key)}
                        className="list__actions-button-delete"
                      >
                        <DeleteOutlined />
                      </div>
                    </div>
                  )}
              </Fragment>
            ))
          );
        },
      },
    ];

    return columns;
  };

  return (
    <Fragment>
      <div className="invitees__wrapper">
        {data?.length ? (
          <div className="invitees__body-wrapper">
            <Table
              title={() => (
                <div className="flex-display flex-align-c">
                  <div style={{ marginLeft: 'auto' }} className="flex-display flex-align-c">
                    {!['VOID', 'COMPLETED'].includes(selectedRfq?.status) && (
                      <H3Text
                        text={(
                          <div onClick={() => setShowAddVendorsDrawer(true)}>
                            <FontAwesomeIcon icon={faCirclePlus} />
                            {' '}
                            Add Participants
                          </div>
                        )}
                        className="invitees__table-action"
                      />
                    )}
                    {!['DRAFT', 'VOID', 'COMPLETED'].includes(selectedRfq?.status) && (
                      <Popover
                        placement="topRight"
                        title="Notify all participants?"
                        content={(
                          <React.Fragment>
                            <Checkbox
                              checked={whatsappAll}
                              onChange={() => setWhatsappAll(!whatsappAll)}
                            >
                              Whatsapp
                            </Checkbox>
                            <Checkbox checked={emailAll} onChange={() => setEmailAll(!emailAll)}>Email</Checkbox>
                            <Button
                              onClick={() => {
                                const filteredData = data.filter((item) => item.product_sku_ids !== null);
                                sendRfqNotification({
                                  participants: filteredData?.map((i) => i?.rfq_participant_id),
                                  notification_type: 'RFQ_INITIAL',
                                  send_whatsapp_notification: whatsappAll,
                                  send_email_notification: emailAll,
                                }, () => {
                                  setShowNotifyPopup(!showNotifyPopup);
                                });
                              }}
                              type="primary"
                              size="small"
                              disabled={!whatsappAll && !emailAll}
                              loading={sendRfqNotificationLoading}
                            >
                              Notify Vendors
                            </Button>
                          </React.Fragment>
                        )}
                        open={showNotifyPopup}
                        onOpenChange={() => setShowNotifyPopup(!showNotifyPopup)}
                        trigger="click"
                      >
                        <H3Text
                          text={(
                            <div style={{ width: '78px', textAlign: 'center' }}>
                              <FontAwesomeIcon icon={faBell} />
                              {' '}
                              Notify All
                            </div>
                          )}
                          className="invitees__table-action"
                        />
                      </Popover>
                    )}
                  </div>
                </div>
              )}
              bordered
              loading={loading}
              showHeader
              size="small"
              columns={getColumns()}
              dataSource={data}
              rowClassName={(record) => (record?.key === editingKey ? 'invitees__editing-key' : '')}
              pagination={false}
              scroll={{ x: 'max-content' }}
            />
          </div>
        ) : (
          <Fragment>
            <div className="invitees__no-invite-wrapper">
              <div className="invitees__no-invite">
                <img className="invitees__no-invite__image" src={NoBom} alt="bom" />
                <H3Text className="invitees__no-invite__text" text="No vendors have been invited to submit the prices." />
                {!['VOID', 'COMPLETED'].includes(selectedRfq?.status) && Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION,
                  Helpers.permissionTypes.CREATE, user) && (
                    <Button
                      className="invitees__no-invite__button hide__in-mobile"
                      onClick={() => {
                        setShowAddVendorsDrawer(true);
                      }}
                      type="primary"
                    >
                      + Invite Vendors
                    </Button>
                  )}
              </div>
            </div>
          </Fragment>
        )}
        <Drawer
          open={showAddVendorsDrawer}
          onClose={() => setShowAddVendorsDrawer(false)}
          width="840px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '790px' }}>
              <H3Text text="Add Participants" className="custom-drawer__title" />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => {
                  setShowAddVendorsDrawer(false);
                  callback();
                }}
              />
            </div>
          </div>
          <RfqVendorSelector participants={selectedRfq?.rfq_participants} selectedRfq={selectedRfq} callback={() => callback()} />
        </Drawer>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, RfqReducers,
}) => ({
  user: UserReducers.user,
  createRfqLoading: RfqReducers.createRfqLoading,
  updateRfqLoading: RfqReducers.updateRfqLoading,
  getRfqByIdLoading: RfqReducers.getRfqByIdLoading,
  updateRfqParticipantLoading: RfqReducers.updateRfqParticipantLoading,
  sendRfqNotificationLoading: RfqReducers.sendRfqNotificationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateRfqParticipant: (payload, callback) => dispatch(RfqActions.updateRfqParticipant(payload, callback)),
  sendRfqNotification: (payload, callback) => dispatch(RfqActions.sendRfqNotification(payload, callback)),
  getRfqById: (orgId, tenantId, rfqId, callback) => dispatch(RfqActions.getRfqById(orgId, tenantId, rfqId, callback)),
});

Invitees.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
  selectedRfq: PropTypes.any,
  loading: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Invitees));
